/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InttraMessageStateDTO { 
    id?: number;
    description?: string;
    name?: string;
    value?: InttraMessageStateDTO.ValueEnum;
}
export namespace InttraMessageStateDTO {
    export type ValueEnum = 0 | 1;
    export const ValueEnum = {
        NUMBER_0: 0 as ValueEnum,
        NUMBER_1: 1 as ValueEnum
    };
}